import { FocusEventHandler, useCallback, useState, FocusEvent, useMemo } from 'react';

export const useHover = () => {
  const [hovered, setHovered] = useState(false);
  const [focused, setFocused] = useState(false);
  const onMouseEnter = useCallback(() => setHovered(true), []);
  const onMouseLeave = useCallback(() => setHovered(false), []);

  const onFocus: FocusEventHandler<Element> = useCallback((_: FocusEvent<Element>) => {
    setFocused(true);
  }, []);

  const onBlur: FocusEventHandler<Element> = useCallback((e: FocusEvent<Element>) => {
    if (!e.currentTarget?.contains(e.relatedTarget)) {
      setFocused(false);
    }
  }, []);

  const hoveredOrFocused = useMemo(() => hovered || focused, [focused, hovered]);

  const reset = useCallback(() => {
    setHovered(false);
    setFocused(false);
  }, []);

  return {
    hovered: hoveredOrFocused,
    hoverProps: {
      onMouseEnter,
      onMouseLeave,
      onFocus,
      onBlur,
    },
    reset,
  };
};
